export default __webpack_public_path__ + "static/media/conf_policy.0a48dfc1.pdf";